<template>

	<transition-group 
		name="alert" 
		tag="div"
		enter-active-class="animate__animated animate__fadeIn animate__faster"
		leave-to-class="animate__animated animate__fadeOut animate__faster"
	> 
		<div key="1" class="featherlight" v-if="shouldShow==true" style="display: block;" v-on:click.self="togglePaymentForm()">
			<div class="featherlight-content" id="payment_form" >
				<button class="featherlight-close-icon featherlight-close" aria-label="Close" v-on:click.self="togglePaymentForm()">✕</button>
				<section class="popup_content featherlight-inner section" style="max-width: 45rem;" v-if="success == false">
					<div class="constraint">
						<h2 v-if="heading!=''">{{ heading }}</h2>
						<p v-if="text!=''">{{ text }}</p>
						<div class="form_style">
							<template v-if="errors != [] && errors != null && Object.keys(errors).length > 0">
								<template v-if="errors.specific">
									<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>{{ errors.message }}</span></p>
								</template>
								<template v-else>
									<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span v-html="formatErrors(errors)"></span></p>
								</template>
							</template>
							
							<table v-if="participants != [] && participants != null && Object.keys(participants).length > 0">
								<tr>
									<th></th>
									<th class="right">Outstanding Balance</th>
									<th class="right">Amount to pay</th>
								</tr>
								<tr v-for="participant in participants" v-if="participant != 'empty'" v-show="(participant_id == 0 || participant_id == participant.id || show_all)">
									<td>{{ participant.name }}</td>
									<td class="right">{{ participant.formatted_outstanding }}</td>
									<td class="right">
										£&nbsp;<input type="number" value="0.00" v-model="participant.to_pay">
									</td>
								</tr>
							</table>
							<p v-if="(participant_id > 0 && !show_all)">
								Paying for multiple people? <button type="button" class="button solid inline small" style="margin-left: 0.5em; align-self: center;" :style="'--accent:' + this.accent" v-on:click="show_all = true">Click here</button>
							</p>

							<p class="styled_checkboxes">
								<input type="checkbox" value="1" v-model="terms" id="payment_terms"><label for="payment_terms">By ticking you confirm that you have read and agree to the <a :href="terms_link" target="_blank">terms and conditions</a></label>
							</p>
							<p>
								<button type="submit" class="button solid arrow wide medium" :class="{spinner: busy}" :disabled="busy || !terms" v-on:click="submitForm()" style="width: max-content; margin-left: auto;" :style="'--accent:' + this.accent">Proceed to Payment</button>
							</p>
						</div>
					</div>
				</section>
				<section class="quote_form_thanks featherlight-inner section" style="max-width: 45rem;" v-else>
					<div class="constraint">
						<h2><i class="fal fa-glass-cheers fa-2x"></i> Thank you for your payment</h2>
						<template v-if="type=='deposit'">
							<p>Your booking has now been confirmed.</p>
							<template v-if="logged_in=='false'">
								<p>Check your email for instructions on creating your account.</p>
							</template>
						</template>
						<p v-if="type=='payment'">A receipt will be sent to your email.</p>
					</div>
				</section>
			</div>
		</div>
	 </transition-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	
	props: [
		'auto_open_data',
		'deposit',
		'minimum_payment',
		'logged_in',
		'terms_link'

	],

	data: () => {
		return {
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			shouldShow: false,
			success: false,
			errors: [],
			uuid: 0,
			participant_id: 0,
			current_participant: {},
			type: 'payment',
			payment_status: '',
			accent: '',
			participants: {},
			working_auto_open_data: null,
			working_deposit: 0,
			busy: false,
			terms: false,
			show_all: false
		}
	},

	computed: {
		heading () {
			if (this.type=='payment' && this.participant_id==0) { return "Make a Payment"; }
			else if (this.type=='payment' && this.participant_id!=0) { return "Make a Payment"; }
			else if (this.type=='deposit') { return "Confirm Your Booking"; }
			else { return ""; }
		},
		text () {
			if (this.type=='payment' && (this.participant_id==0 || this.show_all)) { return "Enter how much you'd like to pay on behalf of each of the participants below."; }
			else if (this.type=='payment' && this.participant_id!=0 && this.participants != [] && this.participants != null && Object.keys(this.participants).length > 0) { return "Enter how much you'd like to pay on behalf of " + (this.current_participant.name ? this.current_participant.name : 'this participant') + "."; }
			else if (this.type=='deposit') { return "To confirm your booking a deposit of £"+this.working_deposit+" is required."; }
			else { return ""; }
		},
	},

	watch: {
		participants: function(value) {
			for (var participant_key in this.participants) {
				var new_val = 0;
				if(this.working_auto_open_data && this.working_auto_open_data.payments) {
					for (var payment_key in this.working_auto_open_data.payments) {
						if(this.participants[participant_key].id == payment_key) {
							new_val = this.working_auto_open_data.payments[payment_key];
						}
					}
				}
				this.participants[participant_key].to_pay = new_val;
			}
		}
	},

	created() {
	},

	mounted() {
		this.working_deposit = this.deposit;
		this.working_auto_open_data = this.auto_open_data;
		if(this.working_auto_open_data != null) {
			this.togglePaymentForm(this.working_auto_open_data.uuid, this.working_auto_open_data.participant_id, this.working_auto_open_data.type, this.working_auto_open_data.accent);
			this.payment_status = this.working_auto_open_data.payment_status
			if(this.payment_status == 'success') { this.success = true; };
			if(this.payment_status == 'fail' || this.payment_status == 'abort') {
				this.errors = {specific: true, message: this.working_auto_open_data.payment_error_message };
			}
		}
	},

	methods: {

		...mapActions(['addAlert']),

		wrap: function(el, wrapper) {
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		},

		setDeposit: function (deposit) {
			this.working_deposit = deposit;
		},

		togglePaymentForm: function(uuid, participant_id, type, accent){
			if(this.shouldShow==true) {
				this.uuid = 0;
				this.participant_id = 0;
				this.shouldShow = false;
				this.success = false;
				this.participants = {};
				this.errors = [];
				this.working_auto_open_data = null;
				this.show_all = false;
			}else{
				this.shouldShow = true;
				this.uuid = uuid
				this.participant_id = participant_id;
				this.type = type
				this.accent = accent;

				this.$nextTick(function() {
					if(this.type=='payment') {
						this.getParticipants();
					}
					this.initStyledSelect();
				});
			}
		},

		getParticipants: function(){
			axios.post('/ajax/getParticipants', {
				uuid: this.uuid
			})
			.then(response => {
				var participants = response.data;
				if (this.participant_id > 0) {
					for (var participant_key in participants) {
						if (participants[participant_key].id == this.participant_id) {
							this.current_participant = participants[participant_key]
						}
					}
				}
				this.participants = participants;
			})
			.catch(error => {
				console.log(error);
			});
		},

		initStyledSelect: function(){
			// do a pure javascript version of the select wrapper code
			for(var i=0; i<document.querySelectorAll(".form_style select, .styled_select").length; i++) {
				var elem = document.querySelectorAll(".form_style select, .styled_select")[i];
				if(!elem.parentElement.classList.contains('select_wrapper')) {
					var wrapper = document.createElement('div');
					wrapper.classList.add("select_wrapper");
					this.wrap(elem, wrapper);
				}
			}
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},

		submitForm: function() {
			var self = this;
			this.busy = true;

			if (this.participant_id == 0 || this.show_all) {
				var participants = this.participants;
			} else { 
				var participants = [this.current_participant];
			}

			axios.post('/ajax/postPaymentForm', {
				uuid: this.uuid,
				participants: participants,
				type: this.type,
				old_transaction_reference: this.working_auto_open_data ? this.working_auto_open_data.transaction_reference : null
			})
			.then(response => {
				if(response.data['redirect']) {
					window.location.href = response.data['redirect'];
				}else{
					this.errors = response.data['errors'];
					document.getElementById('payment_form').scrollIntoView({behavior: "smooth"});
					this.busy = false;
				}
			})
			.catch(error => {
				if(error.response.status == 422) {
					var errors = error.response.data['errors'];
					this.errors = errors;
					document.getElementById('payment_form').scrollIntoView({behavior: "smooth"});
					this.busy = false;
				}
			});
		},

		formatErrors: function(errors) {
			var msg = "";
			for (var e in errors) {
				msg += errors[e] + "<br>";
			}
			return msg;
		}

	}
};
</script>